/*
 * @Author: Jing
 * @Date: 2021-12-24 14:39:20
 * @Descripttion: 
 */
import type { Directive, App } from 'vue'
import QRCode from 'qrcodejs2-fix'

const qrCode:Directive = {
    beforeMount(el, binding) {
        let code = binding.value;
        el.innerHTML = "";
        console.log('code',code)
        var qrnode = new QRCode(el, {
            useSVG: true,
            text: code
        });
    }
}

export function setupQrCodeDirective(app: App) {
    app.directive('qrcode', qrCode);
}

export default qrCode;